import { ContainerState, ContainerActions } from "./types"
import ActionTypes from "./constants"
import {ConfigurationsType} from "../../types/configurations";
import {FIRST_SEARCH_PAGE_NUMBER} from "../../helpers/searchHelper";

export const INITIAL_FORM_DATA = {
  routine: true
};

const resetSearchState = {
  error: "",
  sidebarFirstPartShown: false,
  sidebarSecondPartShown: false,
  sidebarProcessingParametersShown: false,
  loadingInitialData: false,
  searchResultDetails: null,
  isSearchResultDetailsShown: false,
  formData: null,
  searchFiltersSelected: {},
  productionFiltersSelected: {},
  processFiltersSelected: {},
  currentPage: FIRST_SEARCH_PAGE_NUMBER,
  currentMasterItem: null
}

export const initialState = {
  ...resetSearchState,
  configurations: null,
  appParameters: null,
  routine: INITIAL_FORM_DATA.routine,
  tabActiveInLeftSidebar: 0,
  categoryParameterOnUrl: false,
  missionSelected: [],
  multiMissionSelected: []
};

const applicationReducer = (state: ContainerState = initialState, action: ContainerActions): ContainerState => {
  switch (action.type) {
    case ActionTypes.RESET_SEARCH:
      return { ...state, ...resetSearchState, sidebarFirstPartShown: true};

    case ActionTypes.TOGGLE_SIDEBAR_FIRSTPART:
      return { ...state, sidebarFirstPartShown: action.payload };

    case ActionTypes.TOGGLE_SIDEBAR_PROCESSING_PARAMS:
      return { ...state, sidebarProcessingParametersShown: action.payload };

    case ActionTypes.SET_ACTIVE_TAB_ON_LEFT_SIDEBAR:
      return { ...state, tabActiveInLeftSidebar: action.payload };

    case ActionTypes.STORE_INITIAL_DATA_STARTED:
      return { ...state, loadingInitialData: true };

    case ActionTypes.STORE_INITIAL_DATA_SUCCESS:
      return { ...state, ...getInitialDataBy(action.payload), error: "", loadingInitialData: false };

    case ActionTypes.SET_MISSION:
      return { ...state, missionSelected: action.payload };

    case ActionTypes.SET_MULTI_MISSION:
      return { ...state, multiMissionSelected: action.payload};

    case ActionTypes.SET_APPLICATION_ERROR:
      return { ...state, error: action.payload };

    case ActionTypes.TOGGLE_PRODUCT_CATEGORY_FLAG:
      return { ...state, categoryParameterOnUrl: action.payload };

    case ActionTypes.TOGGLE_SIDEBAR_SECONDPART: {
      return action.payload
        ? { ...state, sidebarSecondPartShown: action.payload, searchResultDetails: null, isSearchResultDetailsShown: false}
        : { ...state, sidebarSecondPartShown: action.payload }
    }

    case ActionTypes.STORE_SEARCH_RESULT_DETAILS:
      return { ...state, searchResultDetails: {...action.payload} };

    case ActionTypes.REMOVE_SEARCH_RESULT_DETAILS:
      return { ...state, searchResultDetails: null };

    case ActionTypes.SHOW_PRODUCT_DETAILS:
      return { ...state, isSearchResultDetailsShown: true, sidebarSecondPartShown: false };

    case ActionTypes.HIDE_PRODUCT_DETAILS:
      return { ...state, isSearchResultDetailsShown: false, sidebarSecondPartShown: true };

    case ActionTypes.STORE_FORMDATA_PAYLOAD:
      return { ...state, formData: action.payload };

    case ActionTypes.UPDATE_FORMDATA_PAYLOAD:
      return { ...state, formData: { ...state.formData, ...action.payload }};

    case ActionTypes.RESET_SEARCH_FILTERS_SELECTED:
      return { ...state, searchFiltersSelected: {}};

    case ActionTypes.UPDATE_SEARCH_FILTERS_SELECTED:
      return { ...state, searchFiltersSelected: {...mergeFilters(state.searchFiltersSelected, action.payload)}};

    case ActionTypes.RESET_PRODUCTION_FILTERS_SELECTED:
      return { ...state, productionFiltersSelected: {}};

    case ActionTypes.UPDATE_PRODUCTION_FILTERS_SELECTED:
      return { ...state, productionFiltersSelected: {...mergeFilters(state.productionFiltersSelected, action.payload)}};

    case ActionTypes.INIT_PROCESS_FILTERS_SELECTED:
      return { ...state, processFiltersSelected: {}};

    case ActionTypes.UPDATE_PROCESS_FILTERS_SELECTED:
      return { ...state, processFiltersSelected: {...mergeFilters(state.processFiltersSelected, action.payload)}};

    case ActionTypes.CHANGE_ROUTINE_STATUS:
      return { ...state, routine: action.payload };

    case ActionTypes.SET_APP_PARAMETERS:
      return { ...state, appParameters: action.payload };

    case ActionTypes.SET_CURRENT_PAGE:
      return { ...state, currentPage: action.payload };

    case ActionTypes.SET_CURRENT_MASTER_ITEM:
      return { ...state, currentMasterItem: action.payload };

    default:
      return state
  }
};

const mergeFilters = (oldFilters, newFilters) => {
  const filters = {};
  const mergedFilters = { ...oldFilters, ...newFilters };
  const keys = Object.keys(mergedFilters);
  keys.forEach((k) => {
    if (mergedFilters[k] !== null && mergedFilters[k] !== undefined && mergedFilters[k] !== "") {
      filters[k] = mergedFilters[k];
    }
  });
  return filters;
}

const getInitialDataBy = (configurations: ConfigurationsType) => {
  const missionSelected: string[] = [];
  if ("missions" in configurations && configurations.missions.length === 1) {
    missionSelected.push(configurations.missions[0].code);
  }

  return {
    configurations,
    missionSelected
  }
}

export default applicationReducer;
